import { ref, computed } from "vue";

export default function () {
	
	const field_errors = ref({}); // { email:["Invalid email"] }
	const form_errors = ref([]);

	function parseErrorResponse(e){
		
		if(!e.response){
			console.error(e);
			form_errors.value = ["Problem processing server response"]
		} else if( (e.response.data||{}).errors ){
			field_errors.value = e.response.data.errors;
			form_errors.value = Object.values(e.response.data.errors).reduce((a,c)=>[...a,...c],[]);
		} else {
			form_errors.value = [(e.response.data||{}).message || e];
		}

	}

	function clearErrors(){
		field_errors.value = {};
		form_errors.value = [];
	}

	return {
		field_errors,
		form_errors,
		clearErrors,
		parseErrorResponse,
	}
}